export default {
      id: "ic_aktuelles-usage",
      viewBox: "0 0 95.9 72.63",
      url: __webpack_public_path__ + "assets/icons/icon-sprite.svg#ic_aktuelles-usage",
      toString: function () {
        return this.url;
      }
    }